
const { ccclass, property, menu } = cc._decorator;

@ccclass('PrefabKeyPair')
class PrefabKeyPair{
    @property(cc.Prefab)
    prefab: cc.Prefab = null

    @property(cc.String)
    key: string = ''
}

@ccclass
@menu('custom/PrefabsHolder')
export default class PrefabsHolder extends cc.Component{
    @property([PrefabKeyPair])
    prefabList: PrefabKeyPair[] = []

    getNodeByKey(key: string): cc.Node{
        for (let i = 0; i < this.prefabList.length; i++) {
            const element = this.prefabList[i];
            if(element.key == key){
                return cc.instantiate(element.prefab)
            }
        }
        return null
    }
}
